export const stripString = (string, character) => {
  const before = string.substring(string.indexOf(character) + 1)

  const singleString = before.substring(0, before.indexOf(character))
  return singleString
}

export const stripLastString = (string, character)=>{
  return string.substr(0, string.lastIndexOf(character));
}